/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace component-selector whitespace */

import {
  Component,
  OnInit,
  OnDestroy,
  Input
}                                  from '@angular/core';

import { Subscription            } from 'rxjs';

import { ServiceManager          } from "@/services/service.manager";
import { Action, ActionType      } from '@/models/action';
import { ProjectOpenRecentAction } from '@/actions/project.open.recent.action';
import { Logger                  } from '@/util/logger';
import {ActionService} from "@/services/action.service";

@Component({
  selector: '.dropmenumain',
  template: `
<div
  class="dropmenu-wrapper"
  (mouseenter)="startHover(dropMenuContent)"
  (mouseleave)="endHover(dropMenuContent)"
>
    <span
      #dropMenuTitle
      class="dropmenu-title"
      [innerHTML]="title">
    </span>
    <div #dropMenuContent class="dropmenu-down-content" style="padding: 0; white-space: nowrap;">

      <ul class="dropmenu-menuitems">
        <li
          *ngFor="let action of actions"
          (click)="!action.enabled() || pick(action, dropMenuContent)"
          [class.disabled]="!action.enabled()">
          <div style="margin: 4px; margin-left: 8px; overflow: hidden;">
          <span class="menuitem-icon" [innerHTML]="action.icon"></span>
          <span class="menuitem-label" [innerHTML]="action.label"></span>
          </div>
        </li>

        <li *ngIf="kind == 'project'"><span class="dropmenu-separator"></span></li>

        <li
          *ngFor="let action of recent"
          (click)="!action.enabled() || pick(action, dropMenuContent)"
          [class.disabled]="!action.enabled()">
          <div style="margin: 4px; margin-left: 8px; overflow: hidden;">
            <span class="menuitem-icon" [innerHTML]="action.icon"></span>
            <span class="menuitem-label" [innerHTML]="action.label"></span>
          </div>
        </li>
      </ul>
    </div>
</div>
  `
})

/**
 *
 * @class MainMenuComponent
 *
 * @brief we implement main menu bar bar using a menu class (here) to implement each
 * drop down menu.  A menu is a rendered list of Acton items, so for each "kind" of menu
 * we use a pre-determined list of Actions from the ActionService pool of GUI actions.
 *
 * We also watch for changes to actions, so that when (for example) an action becomes
 * disabled, we have a chance to render that item in the menu again.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class MainMenuComponent implements OnInit, OnDestroy {

  /** The list of actions for this menu, a null means separator */
  public       actions: Action[] = [];

  /** the list of recent project actions (dynamic) */
  public        recent: Action[] = [];

  /** how the template tells us which menu to render */
  @Input()        kind: string;

  /** the menu name */
  public         title: string = 'No Title';

  /** our subscription to changes in actions */
  private  actionWatch: Subscription;

  /** our subscription to project history changes */
  private historyWatch: Subscription;

  /* standard constructor */
  constructor(
    private      services: ServiceManager,
    private actionService: ActionService
  ) {


  }

  /* setup for the Help menu */
  initHelp() {

    this.title = 'Help';

    /* fill in the actions array with the definition of menu items */

    this.actions.push(this.actionService.action(ActionType.Help_Help));
    this.actions.push(this.actionService.action(ActionType.Help_Demos));
    this.actions.push(this.actionService.action(ActionType.Help_FAQ));
    this.actions.push(this.actionService.action(ActionType.Help_Register));
    this.actions.push(this.actionService.action(ActionType.Help_About));

  }

  /* setup for the Project menu */
  initProject() {

    this.title = 'Project';

    /* fill in the actions array with the definition of menu items */

    this.actions.push(this.actionService.action(ActionType.Project_New));
    this.actions.push(this.actionService.action(ActionType.Project_Create_From));
    this.actions.push(this.actionService.action(ActionType.Project_Open));
    this.actions.push(this.actionService.action(ActionType.Project_Delete));
    this.actions.push(this.actionService.action(ActionType.Project_Close));
    this.actions.push(this.actionService.action(ActionType.Project_Rename));
  }

  initScenario() {

    this.title = 'Scenario';
    this.actions.push(this.actionService.action(ActionType.Window_ConnectionViewer));
    this.actions.push(this.actionService.action(ActionType.Window_Diversion));
    this.actions.push(this.actionService.action(ActionType.Window_ScenarioBrowser));
    this.actions.push(this.actionService.action(ActionType.Window_StringLineViewer));
    this.actions.push(this.actionService.action(ActionType.Window_TSO));
    this.actions.push(this.actionService.action(ActionType.Window_WorkBlox));
  }

  initTools() {

    this.title = 'Tools';

    this.actions.push(this.actionService.action(ActionType.Window_FileBrowser));
    this.actions.push(this.actionService.action(ActionType.Window_Jobs));
    this.actions.push(this.actionService.action(ActionType.Window_JSONEdit));
    this.actions.push(this.actionService.action(ActionType.Window_Search));
    this.actions.push(this.actionService.action(ActionType.Window_TextEdit));

  }

  /* setup for the Window menu */
  initWindow() {

    this.title = 'Window';

    this.actions.push(this.actionService.action(ActionType.Window_Project));
    this.actions.push(this.actionService.action(ActionType.Window_Properties));
    this.actions.push(this.actionService.action(ActionType.Window_Restore_Default));
    this.actions.push(this.actionService.action(ActionType.Window_Save_Layout));

  }

  /* setup for the settings menu */
  initSettings() {

    this.title = '<i class="fas fa-cog"></i>';

    /* fill in the actions array with the definition of menu items */

    this.actions.push(this.actionService.action(ActionType.User_Profile));
    this.actions.push(this.actionService.action(ActionType.Admin_Admin));
    this.actions.push(this.actionService.action(ActionType.Admin_Users));
    this.actions.push(this.actionService.action(ActionType.User_Logout));
  }

  /* animate the opening of the drop down */
  startHover(panel: HTMLDivElement) {

    /* add the opened class */

    if (!panel.classList.contains('opened')) {

      panel.classList.add('opened');
    }

  }

  /* animate the closing of the drop-down */
  endHover(panel: HTMLDivElement) {

    /* remove the opened class */

    panel.classList.remove('opened');
  }

  /* user selected a menu item, do it! */
  pick(action:Action, panel: HTMLDivElement) {

    /* close the drop down */

    this.endHover(panel);

    /* do the action */

    if (!action.execute()) {

      Logger.error(`[MainMenuComponent:${this.kind}] could not do action: `, action);
    }
  }

  /** first time setup */
  ngOnInit(): void {

    Logger.debug(`[MainMenuComponent:${this.kind}] constructing...`);

    /* configure for the kind of menu ... */

    switch(this.kind) {

      case 'help':     this.initHelp();     break;
      case 'project':  this.initProject();  break;
      case 'scenario': this.initScenario(); break;
      case 'tools':    this.initTools();    break;
      case 'window':   this.initWindow();   break;
      case 'settings': this.initSettings(); break;
    }

    /* watch for project access history changes */

    if(this.kind === 'project') {

      this.historyWatch = this.services.projects.observeHistory
        .subscribe(history => {

          Logger.debug(`[MainMenuComponent:${this.kind}] new project history: `, history);

          if (!history) {

            /* nothing to do */

            return ;
          }

          /* watch for changes in project history, so we can update Recent projects */

          this.recent = [];

          for(const item of history) {

            this.recent.push(

              new ProjectOpenRecentAction(this.services, item.name, item.key));

          }

        });
    }

    /*
     * watch for updates to gui actions, it means we have to re-render at least
     * that action if its in the menu items for this menu.
     *
     */

    this.actionWatch = this.actionService.onChange()
      .subscribe(action => {

        Logger.debug(`[MainMenuComponent:${this.kind}] action updated: `, action);

        /*
         * for angular, we don't actually have to do anything...because we are using
         * the exact same instances of Action objects in our menu items list (this.actions)
         * as the ones in the action pool, and because Angular change detection compares
         * the items in the array we use in the template...the changes should be detected
         * automatically.
         *
         * But...because we don't directly reference in the template things like "enabled"
         * as a field (we use the enabled() method)...I'm not 100% clear if Angular is
         * smart enough to also add the "expressions" as part of its change detection.
         *
         * We shall see...if Angular isn't smart enough for it...we'll come back and add
         * an explicit flag field that can be used in the template to trigger change
         * detection.
         *
         * @link https://indepth.dev/the-mechanics-of-dom-updates-in-angular/
         *
         */

        return;
      });
  }

  /* clean up! */
  ngOnDestroy() {

    /* stop watching the logged in user */

    if (this.actionWatch) {

      this.actionWatch.unsubscribe();
    }

    if(this.historyWatch) {

      this.historyWatch.unsubscribe();
    }
  }
}
